export default "__VITE_ASSET__DUFVK4W0__"